import script from "./CameraItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./CameraItem.vue?vue&type=script&lang=ts&setup=true"

import "./CameraItem.vue?vue&type=style&index=0&id=0763ebe0&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0763ebe0"]])

export default __exports__